import { useAuth } from '../contexts/AuthContext';
import { useRoles } from '../lib/supabase/roles/supabaseRoleService';
import { Button } from './ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { ChevronUp } from 'lucide-react';
import { Badge } from './ui/badge';

export const RoleEmulator = () => {
  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const { data: roles = [] } = useRoles();
  const { emulatedRole, setEmulatedRole } = useAuth();

  return (
    <div className="fixed bottom-4 left-4 z-50">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" className="gap-2">
            {emulatedRole && (
              <Badge variant="secondary" className="font-normal">
                {emulatedRole.name}
              </Badge>
            )}
            <ChevronUp className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start">
          <DropdownMenuItem 
            onClick={() => setEmulatedRole(null)}
            className="gap-2"
          >
            <span>Reset to Normal</span>
            {!emulatedRole && (
              <Badge variant="secondary" className="font-normal">
                Active
              </Badge>
            )}
          </DropdownMenuItem>
          {roles.map((role) => (
            <DropdownMenuItem
              key={role.id}
              onClick={() => setEmulatedRole(role)}
              className="gap-2"
            >
              <span>{role.name}</span>
              {emulatedRole?.id === role.id && (
                <Badge variant="secondary" className="font-normal">
                  Active
                </Badge>
              )}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}; 